import { useCallback } from 'react'
import useBreakpoint from 'use-breakpoint'
import defaultTheme from 'tailwindcss/defaultTheme'
import { DefaultTheme } from 'tailwindcss/types/generated/default-theme'

// TODO: find a way to have a single source of truth for that, we're not getting the custom breakpoints, just the default ones
type Breakpoint = 'xs' | keyof DefaultTheme['screens']
type ScreensText = Record<Breakpoint, string>
const tailwindScreens: ScreensText = { xs: '0px', ...defaultTheme.screens }

type ScreensNumber = Record<Breakpoint, number>
const BREAKPOINTS: ScreensNumber = Object.entries(tailwindScreens).reduce(
  (prev, cur) => ({
    ...prev,
    [cur[0]]: +(cur[1] as string).replace('px', '')
  }),
  {}
) as ScreensNumber

export function useTailwindBreakpoint() {
  const bp = useBreakpoint(BREAKPOINTS)

  const isLessThan = useCallback(
    (breakpoint: Breakpoint) => bp.breakpoint && BREAKPOINTS[bp.breakpoint] < BREAKPOINTS[breakpoint],
    [bp]
  )

  const isLessOrEqualTo = useCallback(
    (breakpoint: Breakpoint) => bp.breakpoint && BREAKPOINTS[bp.breakpoint] <= BREAKPOINTS[breakpoint],
    [bp]
  )

  const isGreaterThan = useCallback(
    (breakpoint: Breakpoint) => bp.breakpoint && BREAKPOINTS[bp.breakpoint] > BREAKPOINTS[breakpoint],
    [bp]
  )

  const isGreaterOrEqualTo = useCallback(
    (breakpoint: Breakpoint) => bp.breakpoint && BREAKPOINTS[bp.breakpoint] >= BREAKPOINTS[breakpoint],
    [bp]
  )

  return { ...bp, isLessThan, isLessOrEqualTo, isGreaterThan, isGreaterOrEqualTo }
}
